import GraphemeSplitter from 'grapheme-splitter'
import arrayCharacterFullWidth from './fullwidth'
import arrayCharacterHalfWidth from './halfwidth'

const splitter = new GraphemeSplitter()

const getCharacters = string => {
  return splitter.splitGraphemes(string)
}

const convertCharacter = (character, mode) => {
  let arrayCharacter
  if (mode === 'full') {
    arrayCharacter = arrayCharacterFullWidth
    const key = character
    if (typeof arrayCharacter[key] === 'undefined') {
      return character
    }
    return arrayCharacter[key]
  }

  if (mode === 'half') {
    arrayCharacter = arrayCharacterHalfWidth
    const key = character
    if (typeof arrayCharacter[key] === 'undefined') {
      return character
    }
    return arrayCharacter[key]
  }

  return character
}

export const convertToWidthCharacter = (string, mode) => {
  const characters = getCharacters(string)
  let convertString = ''
  characters.forEach(character => {
    convertString += convertCharacter(character, mode)
  })

  return convertString.replace('　', ' ')
}
